module.exports = __webpack_public_path__ + "img/msg.e6338e0.png";